<template>
  <el-table-column
    prop="recorded_at"
    sortable="custom"
    label="Rögzítve"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.recorded_at | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'recorded_at',
  };
</script>
